import { Layout } from "../../../../containers/Layout/Layout";
import { Title } from "../../../../components/UI/Title";
import styles from './AdminAddMemberFamilyPage.module.css';
import { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { userService } from "../../../../services";
import { Text } from "../../../../components/UI";
import { AdminAddMemberFamilyGroupForm } from "../../components/admin-add-member-family-group-form/AdminAddMemberFamilyGroupForm";
import { User } from "../../interface/User";

export const AdminAddMemberFamilyPage = () => {

    const { leader_id } = useParams<{ leader_id: string }>();
    const [userData, setUserData] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                console.log('Fetching user with ID:', leader_id);
                const userId = parseInt(leader_id || '0', 10);
                if (!userId) {
                    setError('ID de usuario inválido');
                    setLoading(false);
                    return;
                }

                const response = await userService.getUserById(userId);
                console.log('API Response:', response);

                if (response.status === 'Ok' && response.data) {
                    setUserData(response.data);
                    setError(null);
                } else {
                    setError('No se encontró información del usuario');
                    setUserData(null);
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                setError('Error al cargar los datos del usuario');
                setUserData(null);
            } finally {
                setLoading(false);
            }
        };

        if (leader_id) {
            fetchUserData();
        }
    }, [leader_id]);

    return (
        <Layout role="ADMIN_ROLE" menu={true}>
            <Text size="small" className="mb-10">
                <Link to={`/admin/familia/${leader_id}`}>Volver a Grupo Familiar de {userData?.first_name}</Link>
            </Text>
            <Title border className="mb-10">Agregar Integrante a Grupo Familiar</Title>
            
            {loading ? (
                <div>Cargando...</div>
            ) : error ? (
                <div className="text-danger">{error}</div>
            ) : userData ? (
                <>
                    <AdminAddMemberFamilyGroupForm userData={userData}/>
                </>
            ) : (
                <div>No se encontró información del usuario</div>
            )}
        </Layout>
    )
}
